module.exports = __webpack_public_path__ + "img/unidadeslectoras.e4c4491d.png";